import { TError } from '@onesource/schemas';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import axios from '../axios';
import { TEACHER_DIRECTORY_PATH } from './entity';
import { getMyProDirectoryRevisionsQueryKey } from './use-get-my-pro-directory-revisions-query';
import { getProDirectoryPendingRevisionQueryKey } from './use-get-pro-directory-pending-revision-query';

export const useDeleteMyProDirectoryRevisionMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<void, TError, { revisionId: number }>({
    mutationFn: async ({ revisionId }) => {
      await axios.delete(`/${TEACHER_DIRECTORY_PATH}/revisions/${revisionId}`);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: getMyProDirectoryRevisionsQueryKey() });
      queryClient.invalidateQueries({ queryKey: getProDirectoryPendingRevisionQueryKey() });
    },
    meta: {
      successMessage: 'Revision deleted.',
      errorMessage: 'Unable to delete revision.',
    },
  });
};
